import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useGlobalName from '@hooks/useGlobalName';
import { ItemOption } from '@models/item';
import useOptionControl from '@store/item/hooks/useOptionControl';

import { optionsIcons, type AvailableOptionName } from './constants/icons';

interface Props {
    option: ItemOption;
    optionGroupId: string;
    itemId: string;
}

function OptionItem({
    option, optionGroupId, itemId,
}:Props) {
    const {
        optionId, salePrice, name, isChangeable, nameEn, nameJa,
    } = option;
    const { isOptionSelected, selectOption } = useOptionControl({ itemId });
    const isSelected = isOptionSelected({ optionId, optionGroupId });
    const optionName = name as AvailableOptionName;
    const { DefaultIcon, SelectedIcon } = optionsIcons[optionName];
    const ResolvedIcon = isSelected ? SelectedIcon : DefaultIcon;

    const handleSelect = () => {
        if (isChangeable) {
            selectOption({ option, optionGroupId, amount: 1 });
        }
    };
    const displayName = useGlobalName({ name, nameEn, nameJa });

    return (
        <Container spacing={8}
            onClick={handleSelect}
            disabled={!isChangeable}
            align='center' >
            <ResolvedIcon/>
            <Text align='center'>
                {displayName}
                {salePrice !== 0 && (
                    <Text color={colors.gray6} as='span'><br/>
                        +{salePrice.toLocaleString()}원
                    </Text>
                )}
            </Text>
        </Container>
    );
}

const Container = styled(Column)<{
    disabled?: boolean;
}>`
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export default OptionItem;
